import { useState } from "react";

import { type OnChangeFn, type VisibilityState, functionalUpdate } from "@tanstack/react-table";

import { columnsKey, readVisibility, writeVisibility } from "@/lib/table-state";

/**
 * Ustun ko'rinishi — sahifa yangilanganda ham saqlanib qoladi.
 *
 * Holat jadvalning ichida emas, sahifada turadi va boshlang'ich qiymatini
 * `localStorage` dan BIRINCHI renderdayoq oladi: ustun avval ko'rinib, keyin
 * yo'qolib "sakramaydi". `defaults` — hech narsa saqlanmaganda yashirin
 * turadigan ikkinchi darajali ustunlar.
 */
export function useColumnVisibility(table: string, defaults: VisibilityState = {}) {
  const key = columnsKey(table);
  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(() => ({
    ...defaults,
    ...readVisibility(key),
  }));

  const onColumnVisibilityChange: OnChangeFn<VisibilityState> = updater => {
    const next = functionalUpdate(updater, columnVisibility);
    writeVisibility(key, next);
    setColumnVisibility(next);
  };

  return { columnVisibility, onColumnVisibilityChange };
}
